import { render, staticRenderFns } from "./MainAside.vue?vue&type=template&id=50c68d02&scoped=true&"
import script from "./MainAside.vue?vue&type=script&lang=js&"
export * from "./MainAside.vue?vue&type=script&lang=js&"
import style0 from "./MainAside.vue?vue&type=style&index=0&id=50c68d02&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c68d02",
  null
  
)

export default component.exports